import React, { useEffect, useState } from "react";
import { api, fmtPrice } from "@/lib/api";
import { TrendingUp, TrendingDown } from "lucide-react";

export const MarketTicker = () => {
  const [quotes, setQuotes] = useState([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/market/ticker");
        if (mounted) setQuotes(data.quotes);
      } catch {}
    };
    load();
    const id = setInterval(load, 8000);
    return () => { mounted = false; clearInterval(id); };
  }, []);

  if (!quotes.length) return <div className="h-11 border-y border-slate-800/60 bg-[#0B0F16]" />;

  const row = [...quotes, ...quotes];

  return (
    <div className="relative overflow-hidden border-y border-slate-800/60 bg-[#0B0F16]" data-testid="market-ticker">
      <div className="qs-marquee flex gap-8 py-3 whitespace-nowrap w-max">
        {row.map((q, i) => {
          const up = q.change_pct >= 0;
          return (
            <div key={i} className="flex items-center gap-2 font-mono-ticker text-sm">
              <span className="text-slate-400">{q.pair}</span>
              <span className="text-slate-100 font-semibold">{fmtPrice(q.price, q.decimals)}</span>
              <span className={`flex items-center gap-0.5 ${up ? "text-emerald-400" : "text-red-400"}`}>
                {up ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
                {up ? "+" : ""}{q.change_pct}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
